module.exports = __webpack_public_path__ + "img/brainfit_8.6286e36a.jpg";